// Built-in fallback for the school settings, in the same shape as `get_school_settings()`.
// The database (`school_settings`, edited under Admin > School Settings) is the source of truth; these values
// only show until it loads, or if it cannot be reached, so contact details are never blank. They mirror the
// seed in `supabase/migrations/20261005000004_settings.sql`: if the school's details change, edit them in the admin.
export const FALLBACK_SETTINGS = {
  school_name: 'KS Montessori & Secondary School',
  address: 'NA 12 7th Rd, Satellite Town, Rawalpindi, 46000, Pakistan',
  phones: [
    { tel: '+923455407603', display: '+92 345 5407603', whatsapp: true },
    { tel: '+923455407601', display: '+92 345 5407601', whatsapp: true },
    { tel: '+923224381381', display: '+92 322 4381381', whatsapp: true }
  ],
  email_general: 'info@ksms.edu.pk',
  email_admissions: 'admissions@ksms.edu.pk',
  website_url: 'https://ksms.edu.pk',
  map_url: 'https://maps.app.goo.gl/4sWaPunPWaCjC642A',
  map_embed_url:
    'https://www.google.com/maps?q=KS%20Montessori%20%26%20Secondary%20School%2C%20NA%2012%207th%20Rd%2C%20Satellite%20Town%2C%20Rawalpindi%2C%2046000%2C%20Pakistan&output=embed',
  facebook_url: null,
  twitter_url: null,
  instagram_url: null,
  contact_message: null,
  academic_year: null,
  privacy_policy: null,
  privacy_policy_version: 0,
  // School-confirmed figures (also seeded in 20261005000012_public_content.sql).
  statistics: [
    { value: '15+', label: 'Years of Excellence' },
    { value: '300+', label: 'Happy Students' },
    { value: '20+', label: 'Expert Teachers' },
    { value: '95%', label: 'Parent Satisfaction' }
  ],
  faqs: [],
  facilities: []
};

export const WHATSAPP_MESSAGE =
  'Hello KS Montessori & Secondary School, I am visiting your website and would like to inquire about admissions and programs. Please assist. Thank you.';

export const whatsappLink = (tel, message = WHATSAPP_MESSAGE) =>
  `https://wa.me/${tel.replace(/^\+/, '')}${message ? `?text=${encodeURIComponent(message)}` : ''}`;
